import React from "react";
import {
  Toolbar,
  CssBaseline,
  AppBar,
  IconButton,
  Avatar,
  Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Accountmenu from "../customComponents/accounts/AccountMenu";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { s3baseUri } from "../../config/config";
import { useAdminContext } from "../../hooks/UseAdminContext";

const drawerWidth = 260;

function AppHeader({ handleDrawerToggle, setIsLoading }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { userInfo, addonCaseNumber } = useAdminContext();

  const open = Boolean(anchorEl);
  const displayCaseNumber = addonCaseNumber || userInfo?.case_number;

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          backgroundColor: "#15978a",
        }}
        elevation={0}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            minHeight: { xs: 56, sm: 64 },
          }}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>

          <h1
            className="mb-0"
            style={{
              flexGrow: 1,
              textAlign: "center",
              color: "#fec013",
              whiteSpace: "nowrap",
              overflow: "hidden",
            }}
          >
            LHG E-Portal
          </h1>

          <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
            {displayCaseNumber && (
              <Box
                sx={{
                  color: "#fff",
                  fontWeight: 600,
                  px: 1,
                  py: 0.5,
                  borderRadius: "20px",
                  mr: 1,
                  fontSize: { xs: "12px", sm: "16px" },
                  textAlign: "center",
                  whiteSpace: "nowrap",
                }}
              >
                Applicant Number
                <br />
                <span style={{ fontWeight: 400 }}>{displayCaseNumber}</span>
              </Box>
            )}

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                position: "relative",
                cursor: "pointer",
              }}
              onClick={handleMenuOpen}
            >
              <Avatar
                src={
                  userInfo?.profile_image
                    ? s3baseUri + userInfo.profile_image
                    : ""
                }
                sx={{ width: 46, height: 46, border: "none" }}
              >
                {!userInfo?.profile_image &&
                  userInfo?.name
                    ?.split(" ")
                    .map((n) => n[0])
                    .slice(0, 2)
                    .join("")}
              </Avatar>
              {open ? (
                <ExpandLess
                  sx={{
                    position: "absolute",
                    backgroundColor: "white",
                    color: "black",
                    bottom: 1,
                    right: -5,
                    fontSize: "15px",
                    borderRadius: "50px",
                  }}
                />
              ) : (
                <ExpandMore
                  sx={{
                    backgroundColor: "white",
                    color: "black",
                    position: "absolute",
                    bottom: 1,
                    right: -5,
                    fontSize: "15px",
                    borderRadius: "50px",
                  }}
                />
              )}
            </Box>
          </Box>

          <Accountmenu
            anchorEl={anchorEl}
            open={open}
            handleClose={handleClose}
          />
        </Toolbar>
      </AppBar>
    </>
  );
}

export default AppHeader;
